import Styles from './BrandKits.module.scss'
import { SelectionCount } from 'components/ImagePickerModal/SelectionCount'
import { ConfirmSelectionButton } from 'components/ImagePickerModal/ConfirmSelectionButton'
import { ScrollContainer } from 'components/ImagePickerModal/ScrollContainer/ScrollContainer'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import InfiniteScroll from 'common/InfiniteScroll/InfiniteScroll'
import { Portal } from 'components/Portal/Portal'
import { BrandKitsProps } from './Types'
import { ImageThumbnail } from 'components/ImagePickerModal/ImageThumbnail/ImageThumbnail'
import { MediaFiles } from 'components/ImagePickerModal/BrandKits/MediaFiles'
import { useState } from 'react'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Chip } from 'components/Chip/Chip'
import { BrandKitLogo } from 'screens/BrandKit/BrandKitLogo/BrandKitLogo'
import { HighDetailedUpload } from 'blaze-ui/icons'
import { useCompletedBrandKits } from 'hooks/queries/brandKits/useCompletedBrandKits'
import { Carousel } from 'components/Carousel/Carousel'

const BrandKits = ({ actionsContainerRef, confirmLabel = 'Add To Post', initialBrandKitId }: BrandKitsProps) => {
  const [selectedBrandKitId, setSelectedBrandKitId] = useState<number | undefined>(initialBrandKitId)
  const context = useImagePickerContext()
  const { selectedImages, toggleSelectedImage, onConfirm } = context
  const { data } = useCompletedBrandKits()

  const handleConfirm = async () => {
    if (context.onBeforeConfirm) {
      const confirmed = await context.onBeforeConfirm(selectedImages)
      if (!confirmed) {
        return
      }
    }
    onConfirm(selectedImages, context)
  }

  return (
    <div data-testid="brandkits-provider">
      <>
        <Portal container={actionsContainerRef}>
          <SelectionCount />
          <ConfirmSelectionButton
            onPress={handleConfirm}
            isDisabled={selectedImages.length === 0}
            confirmLabel={confirmLabel}
          />
        </Portal>
      </>
      <div className={Styles.allUploads}>
        <div className={Styles.selection}>
          <Heading level={5}>Select a Brand Kit or Uploads</Heading>
          <div className={Styles.pills}>
            <Carousel>
              {data?.map((brandKit) => (
                <Chip
                  icon={() => <BrandKitLogo brandKit={brandKit} size={16} />}
                  deletable={false}
                  key={brandKit.id}
                  isSelected={selectedBrandKitId === brandKit.id}
                  onChange={(isSelected) => isSelected && setSelectedBrandKitId(brandKit.id)}
                >
                  {brandKit.name}
                </Chip>
              ))}
              <Chip
                icon={HighDetailedUpload}
                deletable={false}
                isSelected={selectedBrandKitId === undefined}
                onChange={(isSelected) => isSelected && setSelectedBrandKitId(undefined)}
              >
                Uploaded Media
              </Chip>
            </Carousel>
          </div>
        </div>
        <ScrollContainer>
          <MediaFiles brandKitId={selectedBrandKitId}>
            {({ mediaFiles, hasNextPage, fetchNextPage }) => (
              <>
                <div className={Styles.allUploadsGrid}>
                  {mediaFiles.map((mediaFile) => (
                    <div key={mediaFile.id} className={Styles.allUploadsItem}>
                      <ImageThumbnail
                        image={{ ...mediaFile, url: mediaFile.thumbnail_url as string }}
                        onToggleSelect={toggleSelectedImage}
                        isSelected={selectedImages.some((i) => i.url === mediaFile.thumbnail_url)}
                        duration={mediaFile.duration}
                      />
                    </div>
                  ))}
                </div>
                {hasNextPage && (
                  <div className={Styles.infiniteLoader}>
                    <InfiniteScroll hasMore={hasNextPage} loadMore={fetchNextPage} />
                  </div>
                )}
              </>
            )}
          </MediaFiles>
        </ScrollContainer>
      </div>
    </div>
  )
}

export { BrandKits }
